import React, { useEffect, useRef, useContext } from "react"
import styled, { css } from "styled-components"
import { rem } from "polished"

import { LoadedContext } from "./loaded-context"

const CursorEl = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  pointer-events: none;
  width: ${rem(40)};
  height: ${rem(40)};
  z-index: 10;
  margin-top: ${rem(-20)};
  margin-left:${rem(-20)};
  mix-blend-mode: difference;

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border-radius: 999em;
    background: #ff2300;
    transform: scale(0);
    transition: 0.5s;
  }

  ${props =>
    props.loaded &&
    css`
      &::before {
        transform: scale(1);
      }
    `}

  // Initial css solution for now
  @media (hover: none) {
    display: none;
  }

  // @media ${props => props.theme.desktopDown} {
  //   display: none;
  // }

  ${props =>
    props.hideCenter &&
    css`
      &::before {
        transform: scale(0);
      }
    `}
`

const Cursor = props => {
  const loadedContext = useContext(LoadedContext)

  const CursorRef = useRef(null)

  useEffect(() => {
    const mouseCircle = CursorRef.current

    let mousePosX = 0,
      mousePosY = 0

    const cursorMove = e => {
      mousePosX = e.clientX
      mousePosY = e.clientY
    }

    window.addEventListener("mousemove", cursorMove)

    let delay = 6,
      revisedMousePosX = 0,
      revisedMousePosY = 0

    function delayMouseFollow() {
      requestAnimationFrame(delayMouseFollow)

      revisedMousePosX += (mousePosX - revisedMousePosX) / delay
      revisedMousePosY += (mousePosY - revisedMousePosY) / delay

      mouseCircle.style.top = revisedMousePosY + "px"
      mouseCircle.style.left = revisedMousePosX + "px"
    }

    delayMouseFollow()

    return () => {
      window.removeEventListener("mousemove", cursorMove)
    }
  }, [])

  return <CursorEl loaded={loadedContext.loaded} ref={CursorRef}></CursorEl>
}

export default Cursor
